<template lang="pug">
  div.billing.tariff-update
    e-form-modal(
    ref="modalForm"
    @submitModalForm="sendForm()"
    @deleteItem="deleteItem()"
    :hideDeleteButton="false"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
        e-form-tabs()
      slot
        e-form(:formValidator="formValidator")
          div.body
            div.col
              e-form-group(
              name="name"
              label="Наименование"
              :model="fields"
              tabView="tab1"
              :required="true"
              )

            div.col
            div.col

          div.body.body-table
            branch-tariffs(
            :id="itemId"
            :model="fields"
            )


</template>

<script>
  import branchForm from './mixins/branch-form'
  import {billing} from "../../api/api-endpoints"
  import BranchTariffs from "./components/branch-tariffs";

  export default {
    components: {BranchTariffs},
    mixins: [branchForm],
    methods: {
      getItemEndpoint (route) {
        if (!route.params.id) {
          return null
        }
        return billing.branch(route.params.id)
      },
      getUpdateOrCreateUrl () {
        return billing.branchCreateOrUpdate(this.$route.params.id)
      },
      getDeleteUrl (fieldId) {
        return billing.branchDelete(fieldId)
      }
    }
  }
</script>
